import React, { FC } from 'react';
import styled from 'styled-components';

import { pxToRem } from 'utils/convert';
import { colors, spacing, Overline } from 'ui/theme';

const Container = styled.div`
  background-color: ${colors.grey1};
  border-top: ${spacing.single} solid ${colors.grey15};
  border-bottom: ${spacing.single} solid ${colors.grey15};
  /* negative side padding allows for full width headers */
  margin: 0 -${spacing.base} ${spacing.plusHalf};
  padding-left: ${pxToRem(10)};
`;

const ConversionsHeaderContainer = styled(Container)`
  margin-bottom: ${spacing.half};
`;

const Text = styled(Overline)`
  display: flex;
  height: ${pxToRem(28)};
  align-items: center;
`;

export type NodeEditorHeaderProps = {
  title: string;
};

export const NodeEditorHeader: FC<React.PropsWithChildren<NodeEditorHeaderProps>> = ({ title }) => (
  <Container data-test={`section-header-${title.toLowerCase()}`}>
    <Text>{title.toUpperCase()}</Text>
  </Container>
);

export const ConversionsNodeEditorHeader: FC<React.PropsWithChildren<NodeEditorHeaderProps>> = ({
  title,
}) => (
  <ConversionsHeaderContainer>
    <Text>{title.toUpperCase()}</Text>
  </ConversionsHeaderContainer>
);
